














import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import POIForm from '@superUI/Forms/POIForm'
import RequestButton from '@components/RequestButton'

settings =
  name: 'POICreate'
  components: { Back, SuperContainerView, POIForm, RequestButton }

  resources:
    newPOI:
      resourceName: 'poi'
      slug: 'pois/new'

  vue:
    methods:
      hiSave: -> @saveItem('prime.newPOI')
      onSave: (item) -> @$router.push { name: 'POIShowPage', params: { poiId: item.id } }

export default VueOptions.vue settings
